export interface AutomationAppQuickInfo {
  automationAppType: AutomationExtensions;
  updateFieldsCount: number;
  updateListName: string;
}

export enum AutomationExtensions {
  Apsis = 'Apsis',
  ApsisOne = 'ApsisOne',
  MailChimp = 'MailChimp',
  RuleMailer = 'RuleMailer',
  Triggerbee = 'Triggerbee',
  Voyado = 'Voyado',
  Zapier = 'Zapier',
  Pipedrive = 'Pipedrive',
  Klaviyo = 'Klaviyo',
  Emarsys = 'Emarsys',
  Custobar = 'Custobar',
  MailerLite = 'MailerLite',
}

export interface ConsentCheckApiResponse {
  error: any;
  data: boolean;
}

export interface CampaignValidateResponse {
  integration: string;
  listValidate: boolean;
  fieldValidate: boolean;
}
